module.exports = __webpack_public_path__ + "static/media/fm20enu_5.4bc641df.ico";